import { render } from "./Conselheiros.vue?vue&type=template&id=719628bf&scoped=true"
import script from "./Conselheiros.vue?vue&type=script&lang=js"
export * from "./Conselheiros.vue?vue&type=script&lang=js"

import "./Conselheiros.vue?vue&type=style&index=0&id=719628bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719628bf"]])

export default __exports__